import React, { useEffect } from "react";
import OwlCarousel from "react-owl-carousel";
import AOS from "aos";

// Import required CSS files
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import "aos/dist/aos.css";
// import "./Testimonials.css"; // Optional: for additional custom styles

const Testimonials = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  // Testimonials data
  const testimonials = [
    {
      id: 1,
      name: "Amit Khurana",
      role: "@Regal Merchandise",
      image: "assets/img/Socialicons/user.png",
      rating: 5,
      text: "Dm2Legal has been a game-changer for my business. Their platform is intuitive and made filing my GST and income tax returns seamless. The team is professional, responsive, and truly cares about their clients. Highly recommended!"
,
    },
    {
      id: 2,
      name: "Priya Mehta",
      role: "@Jain Realestates",
      image:  "assets/img/Socialicons/user.png",
      rating: 5,
      text:"I was struggling with legal compliance for my startup, but Dm2Legal made it so easy. Their guidance and support saved me so much time and effort. I can’t thank them enough for their quick and reliable service!"
,
    },
    {
      id: 3,
      name: "Ravi Sharma",
      role: "@Food Court",
      image:  "assets/img/Socialicons/user.png",
      rating: 5,
      text: "Finding a trustworthy and efficient legal services platform is rare, but Dm2Legal exceeds expectations. Their document upload and tracking system is flawless, and the team ensured my issues were resolved quickly."
,
    },
    {
      id: 4,
      name: "Sneha Verma",
      role: "@Vaastav Land",
      image:  "assets/img/Socialicons/user.png",
      rating: 5,
      text:"As a first-time entrepreneur, I had no idea how to manage company registration and other legal formalities. Dm2Legal’s team walked me through every step and made the process stress-free. Excellent service!"
,
    },
    {
      id: 5,
      name: "Rajesh Gupta",
      role: "@AMK Digitals",
      image:  "assets/img/Socialicons/user.png",
      rating: 5,
      text:"I’ve used Dm2Legal multiple times for tax filing and compliance issues. Their experts are knowledgeable and always ready to help. The platform is user-friendly and provides updates at every step. Truly reliable!",
    },
    {
      id: 6,
      name: "Neha Singh",
      role: "@Reliable Hardware",
      image:  "assets/img/Socialicons/user.png",
      rating: 5,
      text: "I’m so glad I found Dm2Legal for my property dispute case. The legal advice and documentation services they provided were top-notch. Their customer support is friendly and efficient. Highly satisfied!"
,
    },
  ];

  // Owl Carousel options
  const carouselOptions = {
    items: 2,
    margin: 30,
    loop: true,
    nav: true,
    dots: true,
    autoplay: true,
    autoplayTimeout: 3000,
    navText: [
      '<i className="fa fa-chevron-left"></i>',
      '<i className="fa fa-chevron-right"></i>'
    ], // Custom navigation icons
    responsive: {
      0: { items: 1 },
      768: { items: 2 },
      1200: { items: 3 },
    },
  };

  return (
    <div className="tes7 sp2">
      <div className="container">
        {/* Section Heading */}
        <div className="row">
          <div className="col-lg-6 m-auto text-center">
            <div className="hadding7" data-aos="fade-up">
              <span>
                <img src="assets/img/icons/money.png" alt="Money Icon" />
                Our Testimonials
              </span>
              <div className="space20"></div>
              <h2>Our Clients Speak</h2>
              <p>
                Our client's success stories reflect the quality of our legal services. Hear directly from the businesses and individuals we've had the privilege to assist.
              </p>
            </div>
          </div>
        </div>

        <div className="space60"></div>

        {/* Testimonials Carousel */}
        <div className="row">
          <OwlCarousel
            className="tes7-slider-all owl-carousel"
            {...carouselOptions}
            data-aos="fade-up"
          >
            {testimonials.map((testimonial) => (
              <div className="tes7-single-slider" key={testimonial.id}>
                {/* Icon */}
                <div className="icon">
                  <img src="assets/img/icons/tes7-icon.svg" alt="Icon" />
                </div>

                {/* Rating */}
                <div className="reting">
                  <ul>
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <li key={i}>
                        <i className="fa-solid fa-star"></i>
                      </li>
                    ))}
                    <li className="reting-hadding">({testimonial.rating}) Rating</li>
                  </ul>
                </div>

                {/* Testimonial Text */}
                <p className="pera">{testimonial.text}</p>

                {/* Testimonial Footer */}
                <div className="bottom-hadding">
                  <div className="image">
                    <img src={testimonial.image} alt={testimonial.name} />
                  </div>
                  <div className="headding">
                    <h5>
                      <a href="#">{testimonial.name}</a>
                    </h5>
                    <p>{testimonial.role}</p>
                  </div>
                </div>
              </div>
            ))}
          </OwlCarousel>
        </div>
      </div>
    </div>
  );
};

export default Testimonials;
